import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesMateriales() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "Materiales", items: [
      { label: "Colores", icon: "fas fa-palette", color: "#0d9488", href: "/Colores", enabled: !!(user.menu_articulos && user.menu_colores) },
      { label: "Tipo de Tela", icon: "fab fa-staylinked", color: "#0d9488", href: "/TiposTelas", enabled: !!(user.menu_articulos && user.menu_tipos_telas) },
      { label: "Telas", icon: "fas fa-tape", color: "#0d9488", href: "/ListadoTelas", enabled: !!(user.menu_articulos && user.menu_telas) },
      { label: "Habilitacion", icon: "fas fa-tag", color: "#0d9488", href: "/ListadoHabilitacion", enabled: !!(user.menu_articulos && user.menu_habilitacion) },
    ]},
    { section: "Articulos", items: [
      { label: "Marcas", icon: "far fa-copyright", color: "#2563eb", href: "/Marcas", enabled: !!(user.menu_articulos) },
      { label: "Departamentos", icon: "fas fa-list-ul", color: "#2563eb", href: "/ListadoDepartamentos", enabled: !!(user.menu_articulos) },
      { label: "Lineas", icon: "fas fa-list-ul", color: "#2563eb", href: "/ListadoSubDepartamentos", enabled: !!(user.menu_articulos) },
      { label: "Colecciones", icon: "fa-solid fa-ruler-combined", color: "#2563eb", href: "/Colecciones", enabled: !!(user.menu_articulos) },
      { label: "Variantes Tallas", icon: "fa-solid fa-ruler-combined", color: "#2563eb", href: "/ListadoVariantesTallas", enabled: !!(user.menu_articulos) },
      { label: "Tallas", icon: "fas fa-ruler-horizontal", color: "#2563eb", href: "/ListadoTallas", enabled: !!(user.menu_articulos) },
      { label: "Modelos", icon: "fas fa-tshirt", color: "#2563eb", href: "/ListadoArticulos", enabled: !!(user.menu_articulos) },
    ]},
    { section: "Clientes", items: [
      { label: "Clientes", icon: "fas fa-user-tie", color: "#16a34a", href: "/Clientes", enabled: !!(user.menu_articulos && user.menu_clientes) },
    ]},
    { section: "Proveedores", items: [
      { label: "Proveedores", icon: "fas fa-dolly", color: "#ea580c", href: "/Proveedores", enabled: !!(user.menu_articulos && user.menu_proveedores) },
      { label: "Talleres", icon: "fas fa-dolly", color: "#ea580c", href: "/Maquileros", enabled: !!(user.menu_articulos && user.menu_proveedores) },
    ]},
    { section: "Produccion", items: [
      { label: "Catalogo Procesos", icon: "fas fa-tasks", color: "#7c3aed", href: "/CatalogoProcesos", enabled: !!(user.menu_articulos && user.menu_produccion) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Catálogos"
      descripcion="Materiales, artículos, clientes y proveedores"
      icono="fas fa-book-open"
      color="#0d9488"
      secciones={secciones}
    />
  );
}

export default BotonesMateriales;
